import { render, staticRenderFns } from "./DetectorOverStandard.vue?vue&type=template&id=7038214a&scoped=true"
import script from "./DetectorOverStandard.vue?vue&type=script&lang=js"
export * from "./DetectorOverStandard.vue?vue&type=script&lang=js"
import style0 from "./DetectorOverStandard.vue?vue&type=style&index=0&id=7038214a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038214a",
  null
  
)

export default component.exports